import { EdgeExchangeImpersonationHandoffRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { ExchangeImpersonationHandoff } from '@/modules/auth/use-cases'

export function makeExchangeImpersonationHandoff(): ExchangeImpersonationHandoff {
  return new EdgeExchangeImpersonationHandoffRepository(makeSupabaseEdgeHttpClient()).execute
}
